import Vue from "vue";
import Vuex from "vuex";
import { unMachine } from "./filters";

Vue.use(Vuex);

// Helper function to format title for document.title
function formatTitle(title) {
  if (!title) return "INTERACT-ADAPT";
  const formatted = unMachine(title);
  // Capitalize first letter of each word
  const capitalized = formatted
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return `${capitalized} | INTERACT-ADAPT`;
}

// Plugin to sync document.title with store
const titlePlugin = (store) => {
  store.subscribe((mutation) => {
    if (mutation.type === 'changePageTitle') {
      document.title = formatTitle(mutation.payload);
    }
  });
};

export default new Vuex.Store({
  plugins: [titlePlugin],
  state: {
    loggedIn: false,
    pageTitle: "",
    pageIntroText: "",
    showSidebar: false,
    db: {},
    uid: "",
    loading: false,
    painEntries: [],
    analytics: {},
  },

  mutations: {
    modifyLoggedIn(state, loggedIn) {
      state.loggedIn = loggedIn;
    },
    changePageTitle(state, title) {
      state.pageTitle = title;
    },
    changePageIntroText(state, text) {
      state.pageIntroText = text;
    },
    showSidebar(state) {
      state.showSidebar = true;
    },
    hideSidebar(state) {
      state.showSidebar = false;
    },
    setDB(state, db) {
      state.db = db;
    },
    setUID(state, uid) {
      state.uid = uid;
    },
    modifyLoading(state, loading) {
      state.loading = loading;
    },
    addPainEntry(state, entry) {
      state.painEntries.push(entry);
    },
    clearPainEntries(state) {
      state.painEntries = [];
    },
    setAnalytics(state, analytics) {
      state.analytics = analytics;
    },
  },

  getters: {
    getLoggedInStatus: (state) => state.loggedIn,
    getPageTitle: (state) => state.pageTitle,
    getPageIntroText: (state) => state.pageIntroText,
    getSidebarStatus: (state) => state.showSidebar,
    getDB: (state) => state.db,
    getUID: (state) => state.uid,
    getLoading: (state) => state.loading,
    getPainEntries: (state) => state.painEntries,
    getAnalytics: (state) => state.analytics,
  },
});
